import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface State {
  lobby: {
    createGameOpen: boolean;
  };
  rpcErrorModal: {
    show: boolean;
  };
  insufficientBalanceModal: {
    show: boolean;
  };
  sound: {
    isAudioMuted: boolean;
  };
  connectWalletModal: {
    show: boolean;
  };
}

export interface Actions {
  setLobbyCreateGameOpen: (open: boolean) => void;
  setRpcErrorModalShow: (show: boolean) => void;
  toggleAudioMuted: () => void;
  setAudioMuted: (value: boolean) => void;
  setInsufficientBalanceModalShow: (show: boolean) => void;
  setConnectWalletModalOpen: (show: boolean) => void;
}

export const initialState: State = {
  lobby: {
    createGameOpen: false,
  },
  rpcErrorModal: {
    show: false,
  },
  insufficientBalanceModal: {
    show: false,
  },
  sound: {
    isAudioMuted: false,
  },
  connectWalletModal: {
    show: false,
  },
};

export const useUIStore = create<State & Actions>()(
  persist(
    immer((set, get) => ({
      ...initialState,
      setLobbyCreateGameOpen: (open) => {
        set((state) => {
          state.lobby.createGameOpen = open;
        });
      },
      setRpcErrorModalShow: (show) => {
        set((state) => {
          state.rpcErrorModal.show = show;
        });
      },
      toggleAudioMuted: () => {
        set((state) => {
          state.sound.isAudioMuted = !state.sound.isAudioMuted;
        });
      },
      setAudioMuted: (value) => {
        set((state) => {
          state.sound.isAudioMuted = value;
        });
      },
      setInsufficientBalanceModalShow: (show) => {
        set((state) => {
          state.insufficientBalanceModal.show = show;
        });
      },
      setConnectWalletModalOpen: (show) => {
        set((state) => {
          state.connectWalletModal.show = show;
        });
      },
    })),
    { name: 'uiStore' },
  ),
);
